export const CATEGORY_META = {
  prep: {
    label: 'Preparation',
    badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    card: 'border-emerald-200 bg-emerald-50',
    bar: 'bg-emerald-500',
    dot: 'bg-emerald-500',
  },
  cook: {
    label: 'Cooking',
    badge: 'bg-orange-100 text-orange-800 border-orange-200',
    card: 'border-orange-200 bg-orange-50',
    bar: 'bg-orange-500',
    dot: 'bg-orange-500',
  },
  oven: {
    label: 'Oven',
    badge: 'bg-red-100 text-red-800 border-red-200',
    card: 'border-red-200 bg-red-50',
    bar: 'bg-red-500',
    dot: 'bg-red-500',
  },
  wait: {
    label: 'Waiting',
    badge: 'bg-blue-100 text-blue-800 border-blue-200',
    card: 'border-blue-200 bg-blue-50',
    bar: 'bg-blue-500',
    dot: 'bg-blue-500',
  },
};

export const RESOURCE_LABELS = {
  oven: 'Oven',
  stove: 'Cooktop',
  mixer: 'Mixer',
};

export function formatClockTime(date) {
  if (!date) {
    return '—';
  }
  return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function formatCountdown(totalMs) {
  const safeMs = Math.max(0, totalMs);
  const totalSeconds = Math.floor(safeMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatDurationMinutes(minutes) {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins ? `${hours}h ${mins}m` : `${hours}h`;
}

export function toTimeInputValue(date) {
  const value = new Date(date);
  const hours = String(value.getHours()).padStart(2, '0');
  const minutes = String(value.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function applyTimeToToday(timeValue, baseDate = new Date()) {
  const [hours, minutes] = timeValue.split(':').map(Number);
  const result = new Date(baseDate);
  result.setHours(hours, minutes, 0, 0);
  return result;
}

export function computeAnchoredTimes(totalMinutes, anchorMode, anchorDate) {
  const anchor = new Date(anchorDate);
  if (anchorMode === 'serve') {
    const serveAt = anchor;
    const startAt = new Date(serveAt.getTime() - totalMinutes * 60 * 1000);
    return { startAt, serveAt };
  }

  const startAt = anchor;
  const serveAt = new Date(startAt.getTime() + totalMinutes * 60 * 1000);
  return { startAt, serveAt };
}

export function anchorSteps(steps, startAt) {
  const base = new Date(startAt);
  return steps.map((step) => ({
    ...step,
    plannedStartAt: new Date(base.getTime() + step.start * 60 * 1000),
    plannedEndAt: new Date(base.getTime() + step.end * 60 * 1000),
  }));
}

export function normalizeScheduleResult(result) {
  const titleByRecipe = Object.fromEntries(
    (result.recipes || []).map((recipe) => [recipe.id, recipe.title || recipe.id])
  );

  return (result.timeline || []).map((row) => ({
    ...row,
    recipeTitle: row.recipeTitle || titleByRecipe[row.recipe] || row.recipe,
  }));
}

export function defaultSessionTitle(recipes) {
  if (!recipes?.length) {
    return "Tonight's meal";
  }
  if (recipes.length === 1) {
    return recipes[0].title;
  }
  return recipes.map((recipe) => recipe.title).join(' · ');
}

export function getScheduleWarning(totalMinutes, anchorMode, anchorDate) {
  const now = new Date();
  const { startAt, serveAt } = computeAnchoredTimes(totalMinutes, anchorMode, anchorDate);

  if (anchorMode === 'serve' && startAt < now) {
    const minutesLate = Math.ceil((now.getTime() - startAt.getTime()) / 60000);
    const earliestServe = new Date(now.getTime() + totalMinutes * 60 * 1000);
    return `You should have started ${minutesLate} min ago. If you start now, the earliest finish is ${formatClockTime(earliestServe)}.`;
  }

  if (anchorMode === 'start' && serveAt < now) {
    return null;
  }

  return null;
}
